export const gender = {
  MALE: 'male',
  FEMALE: 'female',
} as const

export type Gender = typeof gender[keyof typeof gender]

export const messageSender = {
  USER: 'user',
  AI: 'ai',
} as const

export const contentType = {
  WELCOME: 'welcome',
  USER_MESSAGE: 'user-message',
  USER_FILE_MESSAGE: 'user-file-message',
  UPLOAD_LABS: 'upload-labs',
  ERROR: 'error',
  DRUGS: 'drugs',
  ABOUT_SINA: 'about-sina',
  ARTICLES_NEWS: 'articles-news',
  LABS: 'labs',
  URL_SOURCE: 'url-source',
  SYMPTOM_ADVICE: 'symptom-advice',
  SYMPTOM_ADVICE_LABS: 'symptom-advice-labs',
  SYMPTOM_ADVICE_GUEST: 'symptom-advice-guest',
  TECHNICAL_ISSUE: 'technical-issue',
  NOT_MEDICAL_QUESTION: 'not-medical-question',
  NOT_FOUND_IN_RAG: 'not-found-in-rag',
  EMERGENCY: 'emergency',
  MENTAL_HEALTH: 'mental_health',
  TALK_DOCTOR: 'talk_doctor',
  ILIK_HEALTH: 'dermatology',
  WEIGHT_LOSS: 'weight-loss',

  CHOOSE_MEDIUM: 'choose-medium',
  NEED_SUBSCRIPTION: 'need-subscription',
  VERIFY_PHONE: 'verify-phone',
  CONSULTATION: 'consultation',
} as const

export type ContentType = typeof contentType[keyof typeof contentType]

export const errorTypes = {
  UNSUPPORTED_FORMAT: 'unsupported_format',
  UNCLEAR_DOCUMENT: 'unclear_document',
  NO_LAB_VALUES: 'no_lab_values',
  CONNECTION_ERROR: 'connection_error',
  INVALID_DATA: 'invalid_data',
  UNCLEAR_OR_INCOMPLETE: 'unclear_or_incomplete',
  UNSUPPORTED_TOPIC: 'unsupported_topic',
  FILE_SIZE_EXCEEDED: 'file_size_exceeded',
  GENERAL_ERROR: 'general_error',
  MULTIPLE_IMAGES: 'multiple_images',
}

export type FileErrorTypes = typeof errorTypes[keyof typeof errorTypes]

export const streamMessageType = {
  SINA_MESSAGE: 'sina_message',
  FINISH: 'finish',
  CONTENT: 'content',
  CLASSIFICATION: 'classification',
  USER_MESSAGE: 'user_message',
  SEARCH: 'search',
  EXTERNAL_SEARCH: 'external_search',
  METADATA: 'metadata',
  OTHER_KEYS: 'other_keys',
  STATUS: 'status',
  ERROR: 'error',
} as const

export type StreamMessageType = typeof streamMessageType[keyof typeof streamMessageType]
